export default __webpack_public_path__ + "static/media/Screenshot_1.bea9a2a6.png";